/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';
/**
 * The internal dependencies.
 */
import CheckIcon from '../../../../assets/images/temp/ico-checkmark-circle.png';
import Camera from '../../../../components/task/working/report/camera';

const Wrapper = styled.div`
	display: flex;
`;

const ContentWrapper = styled.div`
	width: 76%;
	margin-right: 32px;
`;

const AsideWrapper = styled.div`
	margin-top: 86px;
`;

const TitleWrapper = styled.div`
	font-size: 25px;
	margin-bottom: 26px;

	& span {
		font-weight: 700;
	}

	& span + span {
		margin-left: 33px;
	}
`;
const Title = styled.h4`
	font-size: 40px;
	line-height: 1;
	color: #1c9d05;
	margin-bottom: 26px;
`;

const DataWrapper = styled.div`
	display: flex;
	margin-bottom: 33px;
`;

const Data = styled.div`
	display: flex;
	flex-direction: column;
	font-size: 20px;
	font-weight: ${({bold}) => bold ? '700' : '400'};
	line-height: 1.5;

	& + div {
		margin-left: 25px;
	}
`;

const MessageWrapper = styled.div`
	font-size: 20px;
	margin-bottom: 33px;

	& p {
		margin-bottom: 33px;
	}
`;

const CompleteMessage = styled.p`
	font-size: 20px;

	& img {
		margin-right: 10px;
	}
`;

const Test = ({
                  message,
                  photos,
                  step,
                  quantity,
                  user,
                  workplace,
                  taskQuantity,
                  shortNumber,
              }) => (
    <Wrapper>
        <ContentWrapper>
            <TitleWrapper>
                <Title>Fehler melden</Title>

                <div>
                    <span>{shortNumber}</span>

                    <span>{taskQuantity}</span> Stk.
                </div>
            </TitleWrapper>

            <DataWrapper>
                <Data>
                    <p>Arbeitschritt:</p>

                    <p>Arbeitsplatz:</p>

                    <p>Mitarbeiter:</p>
                </Data>

                <Data bold>
                    <p>{step}</p>

                    <p>{workplace}</p>

                    <p>{user}</p>
                </Data>
            </DataWrapper>

            <MessageWrapper>
                <p>
                    <strong>Beschreibung:</strong>
                </p>

                {message}
            </MessageWrapper>

            <CompleteMessage>
                <img src={CheckIcon}/>

                Der Mitarbeiter von Arbeitsschritt 4 wurde informiert.
            </CompleteMessage>
        </ContentWrapper>

        {photos.filter(v => v).length > 0 && (
            <AsideWrapper>
                <Camera photos={photos}/>
            </AsideWrapper>
        )}
    </Wrapper>
);

export default Test;



// WEBPACK FOOTER //
// ./src/components/task/working/report/completed.js